import { render } from "./GroupTerm.vue?vue&type=template&id=d5f1dbce&scoped=true"
import script from "./GroupTerm.vue?vue&type=script&lang=js"
export * from "./GroupTerm.vue?vue&type=script&lang=js"

import "./GroupTerm.vue?vue&type=style&index=0&id=d5f1dbce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5f1dbce"]])

export default __exports__